import { createFileRoute } from "@tanstack/react-router";
import { OrganizationEditPage } from "../../../components/organizations/OrganizationEditPage";
import { requireAuth, requirePermission, requireModuleAccess, MODULE_WORKSPACE } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/workspace/organizations/$orgId/edit")({
  beforeLoad: () => {
    requireAuth()();
    requireModuleAccess(MODULE_WORKSPACE)();
    requirePermission("organization:update")();
  },
  component: OrganizationEditRoute,
});

function OrganizationEditRoute() {
  const { orgId } = Route.useParams();
  return <OrganizationEditPage orgId={orgId} />;
}
